import { Link } from "react-router-dom";
import styles from "../LandingV2.module.scss";
import { BsArrowRightShort } from "react-icons/bs";
import { CouponComponent } from "../../CustomerCoupons/CustomerCoupons";
import { Carousel } from "antd";

export const CouponSlider = () => {
  // dummy coupon data
  const coupons = [
    {
      id: 1,
      product: {
        id: 1,
        name: "Red Chilli Pickle",
        image:
          "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
        is_bio: true,
        is_vegan: true,
        is_new: true,
        brand: "Priya",
      },
      discount: "25",
      with_membership: false,
      valid_until: "15.03.2023",
      is_new: true,
    },
    {
      id: 2,
      product: {
        id: 1,
        name: "Red Chilli Pickle",
        image:
          "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
        is_bio: false,
        is_vegan: true,
        is_new: true,
        brand: "Priya",
      },
      discount: "25",
      valid_until: "15.03.2023",
    },
    {
      id: 3,
      product: {
        id: 1,
        name: "Red Chilli Pickle",
        image:
          "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
        is_bio: true,
        is_vegan: false,
        is_new: true,
        brand: "Dev",
      },
      discount: "32",
      valid_until: "18.03.2023",
    },
    {
      id: 3,
      product: {
        id: 1,
        name: "Red Chilli Pickle",
        image:
          "https://desi-fresh.b-cdn.net/image/Product%20Image%20(1)-6j7BD.png",
        is_bio: true,
        is_vegan: true,
        is_new: false,
        brand: "Dev",
      },
      discount: "29",
      valid_until: "18.03.2023",
    },
  ];

  return (
    <div style={{ margin: "2rem" }} className={"dtr " + styles.coupon_slider}>
      <div className="see_more_title">
        <h2>Coupons</h2>
        <Link to={"/customer/coupons"} className={styles.view_all}>
          <span>See More</span>
          <BsArrowRightShort size={20} />
        </Link>
      </div>
      <Carousel
        dots={false}
        autoplay={true}
        slidesToShow={window.innerWidth > 576 ? 4 : 1}
      >
        {coupons.map((coupon, index) => (
          <div className={styles.coupon_slider__item} key={index}>
            <CouponComponent coupon={coupon} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};
